import { MediaType } from '../../types/media/media.type';
import { Image } from '../image/image.model';
import { IMediaItem } from './media-item.model';

export interface IMediaImageConfig {
    image: Image;
    title: string;
    type?: MediaType;
}

export class MediaImage implements IMediaItem {
    image: Image;
    title: string;
    type?: MediaType;

    constructor(...args: [Image, string] | [IMediaImageConfig]) {
        if (args.length === 1) {
            const config = args[0] as IMediaImageConfig;
            this.image = config.image;
            this.title = config.title;
            this.type = config.type ?? 'image';
        } else {
            const [image, title] = args as [Image, string];
            this.image = image;
            this.title = title;
            this.type = 'image';
        }
    }
}
